import { RootState } from '..';
import { configAdapter } from './configuratorSlice';

export const configSelectors = configAdapter.getSelectors((state: RootState) => state.configurator.configs);

export const getExperlogixConfigs = (state: RootState) => configSelectors.selectAll(state);
